import omit from 'lodash/omit';
import {
  AddressDTO,
  InsuranceDTO,
  PatientSummaryDTO,
} from 'dtos';
import dayjs, {
  Dayjs,
} from 'utils/dayjs';

export function getPatientDemographics({
  firstName,
  middleName,
  lastName,
  formattedNames,
  genderDescription,
  dateOfBirth,
}: PatientSummaryDTO) {
  return {
    firstName,
    middleName,
    lastName,
    genderDescription,
    dateOfBirth: dayjs(dateOfBirth ?? ''),
    formattedNames,
  };
}

type Insurance = Partial<Omit<InsuranceDTO, 'insuranceDOB'>>
 & { insuranceDOB?: Dayjs };
export function getDemographicsFromInsurance({
  insuranceOwnerFirstName: firstName,
  insuranceOwnerMiddleName: middleName,
  insuranceOwnerLastName: lastName,
  insuranceOwnerDOB: dateOfBirth,
  insuranceOwnerGenderDescription: genderDescription,
  insuranceOwnerFormattedNames: formattedNames,
}: Insurance) {
  return {
    firstName,
    middleName,
    lastName,
    genderDescription,
    formattedNames,
    dateOfBirth,
  };
}

export function getPatientAddress(address: Partial<AddressDTO>) {
  return omit(address, ['nickName', 'serviceFacilityName', 'serviceFacilityNpi']);
}
